import { Button } from "@/components/ui/button";
import { Monitor, Zap, X } from "lucide-react";
import { useState } from "react";
import { usePerformance } from "@/contexts/PerformanceContext";

export const PerformanceBanner = () => {
  const { isSmartTV, lightModeEnabled, toggleLightMode } = usePerformance();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem('performance_banner_dismissed') === 'true';
    } catch {
      return false;
    }
  });

  const handleDismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem('performance_banner_dismissed', 'true');
    } catch (error) {
      console.warn('Failed to save banner dismissal:', error);
    }
  };

  // Show if Smart TV is detected OR if light mode is manually enabled
  if ((!isSmartTV && !lightModeEnabled) || dismissed) return null;

  return (
    <div className="fixed top-16 left-0 right-0 z-40 animate-in slide-in-from-top duration-500">
      <div className="bg-accent/90 backdrop-blur-sm border-b border-accent-foreground/20">
        <div className="container mx-auto px-4 py-3">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 justify-between">
            {/* Message */}
            <div className="flex items-start gap-3 flex-1">
              <Monitor className="w-5 h-5 text-accent-foreground mt-0.5 flex-shrink-0" />
              <div className="flex-1">
                <p className="text-sm font-medium text-accent-foreground mb-1">
                  {isSmartTV ? "Smart TV Detected" : "Light Mode Active"}
                </p>
                <p className="text-xs text-accent-foreground/80">
                  {lightModeEnabled 
                    ? "Light mode is active for optimal TV performance (animations and heavy features disabled)."
                    : "Enable light mode for better performance on your Smart TV."}
                  {isSmartTV && (
                    <span className="block mt-1">
                      Not a TV? <button onClick={toggleLightMode} className="underline hover:text-accent-foreground">Click here to disable light mode</button>
                    </span>
                  )}
                </p>
              </div>
            </div>

            {/* Actions */}
            <div className="flex items-center gap-2 flex-shrink-0">
              <Button
                size="sm"
                variant="secondary"
                onClick={toggleLightMode}
                className="gap-2"
              >
                <Zap className="w-4 h-4" />
                {lightModeEnabled ? "Disable Light Mode" : "Enable Light Mode"}
              </Button>
              <Button
                size="sm"
                variant="ghost"
                onClick={handleDismiss}
                className="gap-2"
              >
                <X className="w-4 h-4" />
                Dismiss
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
